<template>
  <aside class="page-aside">
    <section class="aside-member">
      <!--      <header class="aside-member-header">-->
      <!--&lt;!&ndash;        <h3 class="title">참가{{ isGroup ? '그룹' : '인원' }} <em class="count">{{ refinedItems.length }}</em></h3>&ndash;&gt;-->
      <!--        <h3 class="title">참가자</h3>-->
      <!--      </header>-->
      <div class="aside-member-body">
        <div class="member-search">
          <div class="member-search-field">
            <input v-model.trim="keyword" type="text" class="kb-form-control" :placeholder="`직원 검색`" @keyup.enter="searchMember"/>
            <button class="kb-btn-search">
              <i class="icon-search"></i>
            </button>
          </div>
        </div>

        <div class="member-mask">
          <ul ref="membersEl" class="member-list">
              <li v-for="(item, index) in memberList" class="member-item" :key="index">
                <div class="member">
                  <router-link v-if="item.lrnerId==session.lrnerId" :to="{name: 'SSLTotalMy', params: {distCrseCd:'total', lrnTrgtGrpMstSn:0}}" class="member-link" @click="closeMember"></router-link>
                  <router-link v-else :to="{name:'SSLLearnerBoard', params: {lrnerId: item.lrnerId}}" class="member-link"></router-link>
                  <div class="member-badge" v-if="item.tag == '11'">
                    <div style="position: absolute; width: 38px; height: 38px; background: rgba(0, 0, 0, 0); z-index: 1; top: 0px; right: -35px; border-radius: 16px;">
                      <img src="@/assets/lxp/mobile/images/ssl/update/crown.gif" alt="" style="width: 35px;height: 35px;position: relative;top: 2px;left: 2px;">
<!--                    <div class="badge badge-primary" v-if="item.tag=='11'"></div>-->
                    </div>
                  </div>
                  <div class="member-avatar" :style="item.tag == '11'?'border-radius: 16px;border: 2px solid #FFBC00;':''">
                    <CommonTypeImage
                        :img-src="item.imgUrl"
                        theme="profile"
                    />
                  </div>

                  <div class="member-content" style="width:180px">
                    <strong class="name">{{ item.lrnerNm }}·{{ item.deptNm}}</strong>
                                        <p class="team">{{ item.crseNm }}</p>
                  </div>
                  <div class="member-follow" :class="{'is-active': item.tag != ''}">
                    <button class="kb-btn-follow" :class="{'kb-btn-follow-friends': item.tag == '13', 'badge-gold': item.tag == '12','kb-btn-follow-mate': item.tag == '11'}">
                      <span class="text">{{ item.tag == '11' ? '최우수' : (item.tag=='12'?'매우우수':'우수') }}</span>
                    </button>
                  </div>
                </div>
              </li>

          </ul>
        </div>
      </div>
    </section>
  </aside>
</template>
<script>

import {sslRewardMemberSetup} from '@/assets/js/modules/ssl/setup/ssl-learn-setup';
import CommonTypeImage from '@/components/common/CommonTypeImage.vue';

export default {
  name: 'SSLRewardMember',
  components: {CommonTypeImage},
  setup: sslRewardMemberSetup
}
</script>

<script setup>
</script>